import React, {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import {SearchDetailContext} from './SearchDetailContext';
import './searchDetailDrawer.css';

/**
 * 상세 검색 조건 — TopMenu 오른쪽에서 슬라이드 인
 */
function SearchDetailDrawer({open, onClose, children, title = '검색조건'}) {
    const [slidIn, setSlidIn] = useState(false);

    useEffect(() => {
        if (!open) return undefined;

        const onKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = prevOverflow;
        };
    }, [open, onClose]);

    useEffect(() => {
        if (!open) {
            setSlidIn(false);
            return undefined;
        }
        const id = requestAnimationFrame(() => setSlidIn(true));
        return () => cancelAnimationFrame(id);
    }, [open]);

    if (!open) return null;

    return createPortal(
        <>
            <div className="drawer-background search-detail-drawer-backdrop show" onClick={onClose} aria-hidden="true"/>
            <div
                className="search-detail-drawer drawer-view-lefter"
                style={{
                    width: 'min(480px, 92vw)',
                    left: 'var(--search-drawer-offset, var(--top-menu-width, 0px))',
                    transform: slidIn ? 'translateX(0)' : 'translateX(-100%)',
                    transition: 'transform 0.3s ease, left 0.25s ease-in-out',
                }}
                role="dialog"
                aria-modal="true"
                aria-label={title}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="search-drawer-top">
                    <h2 className="search-drawer-top__title">{title}</h2>
                    <button
                        type="button"
                        className="search-drawer-top__close"
                        onClick={onClose}
                        aria-label="닫기"
                    >
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>
                <div className="search-detail-drawer__body">
                    <SearchDetailContext.Provider value={true}>
                        {children}
                    </SearchDetailContext.Provider>
                </div>
            </div>
        </>,
        document.body,
    );
}

export default SearchDetailDrawer;
